import React, { useEffect, useState } from "react";
import MainLayout from "./layouts/MainLayout";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import "./App.css";
import {
  AboutUs,
  Donate,
  Donations,
  FAQ,
  Home,
  News,
  Site,
  Sites,
} from "./pages";
import { eagle_icon } from "./assets/images";

// Loading screen component
const LoadingScreen = () => {
  return (
    <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-white z-50">
      <img
        src={eagle_icon}
        alt="Logo"
        className="w-32 h-22 animate-pulse transition-transform duration-1000 ease-in-out scale-100 hover:scale-110"
      />
    </div>
  );
};
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const App = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      <ScrollToTop />
      {loading ? (
        <LoadingScreen />
      ) : (
        <MainLayout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/sites" element={<Sites />} />
            <Route path="/sites/:id" element={<Site />} />
            <Route path="/news" element={<News />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/donate" element={<Donate />} />
            <Route path="/donations/:id" element={<Donations />} />
          </Routes>
        </MainLayout>
      )}
    </Router>
  );
};

export default App;
